import { render, staticRenderFns } from "./my-collect-bus.vue?vue&type=template&id=5f77adfb&scoped=true&"
import script from "./my-collect-bus.vue?vue&type=script&lang=js&"
export * from "./my-collect-bus.vue?vue&type=script&lang=js&"
import style0 from "./my-collect-bus.vue?vue&type=style&index=0&id=5f77adfb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f77adfb",
  null
  
)

export default component.exports